/*
 * Middle Things — country/currency switcher enhancement.
 *
 * Why this is a standalone asset rather than inline in the snippet:
 * Gizmo loads the country switcher panel via XHR (header.liquid points
 * sht-localization at `?section_id=country-switcher-header`) and injects
 * the response with innerHTML. Browsers do not execute <script> tags
 * inserted that way, so inline JS never fires. This file is loaded once
 * via layout/theme.liquid and uses a MutationObserver to bind to any
 * country switcher node that lands in the DOM at any time.
 */
(function () {
  'use strict';

  // ISO-3166 alpha-2 → flag emoji via Unicode regional indicator symbols.
  // FR → 🇫🇷, US → 🇺🇸, etc.
  function iso2flag(iso) {
    if (!iso || iso.length !== 2) return '';
    var A = 0x1F1E6;
    var u = iso.toUpperCase();
    var c1 = u.charCodeAt(0);
    var c2 = u.charCodeAt(1);
    if (c1 < 65 || c1 > 90 || c2 < 65 || c2 > 90) return '';
    return String.fromCodePoint(A + c1 - 65, A + c2 - 65);
  }

  function injectFlags(root) {
    var nodes = (root || document).querySelectorAll(
      '.mt-cswitch__flag, .mt-cswitch__btn-flag'
    );
    nodes.forEach(function (el) {
      if (el.dataset.mtFlagged) return;
      var iso = el.getAttribute('data-iso');
      if (!iso) return;
      var flag = iso2flag(iso);
      if (flag) {
        el.textContent = flag;
        el.dataset.mtFlagged = '1';
      }
    });
  }

  function bindSearch(root) {
    var inputs = (root || document).querySelectorAll('[data-mt-cswitch-search]');
    inputs.forEach(function (input) {
      if (input.dataset.mtBound) return;
      input.dataset.mtBound = '1';

      var panel = input.closest('.mt-cswitch__panel');
      if (!panel) return;
      var items = panel.querySelectorAll('.mt-cswitch__item');
      var sep = panel.querySelector('.mt-cswitch__sep');
      var empty = panel.querySelector('.mt-cswitch__empty');

      function applyFilter(q) {
        q = (q || '').trim().toLowerCase();
        var visibleCount = 0;
        items.forEach(function (li) {
          // Priority items are duplicates of entries in the alphabetical list —
          // hide them while searching so results don't show twice.
          if (li.classList.contains('mt-cswitch__item--priority')) {
            li.hidden = q.length > 0;
            return;
          }
          var name = li.getAttribute('data-name') || '';
          var iso  = (li.getAttribute('data-iso') || '').toLowerCase();
          var cur  = li.getAttribute('data-currency') || '';
          var match = !q || name.indexOf(q) !== -1 || iso.indexOf(q) !== -1 || cur.indexOf(q) !== -1;
          li.hidden = !match;
          if (match) visibleCount++;
        });
        if (sep) sep.hidden = q.length > 0;
        if (empty) empty.hidden = visibleCount > 0;
      }

      input.addEventListener('input', function () { applyFilter(input.value); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { input.value = ''; applyFilter(''); }
      });

      // Auto-focus the search field when the country switcher button is opened.
      // The button might be elsewhere in the DOM (Gizmo lazy-loads the panel),
      // so find it by walking up.
      var container = panel.closest('sht-country-switcher, sht-localization, .country-switcher__wrapper');
      if (container) {
        var btn = container.querySelector('.js-country-switcher-btn');
        if (btn && !btn.dataset.mtFocusBound) {
          btn.dataset.mtFocusBound = '1';
          btn.addEventListener('click', function () {
            setTimeout(function () { input.focus(); }, 100);
          });
        }
      }
    });
  }

  function enhance(root) {
    injectFlags(root);
    bindSearch(root);
  }

  // Initial pass for anything already in the DOM (e.g. button flag on first paint).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhance(document); });
  } else {
    enhance(document);
  }

  // The actual switcher panel arrives later, after the user clicks the button
  // and Gizmo XHRs the section HTML. Watch for new nodes and bind to them.
  var mo = new MutationObserver(function (mutations) {
    var sawSwitcher = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (
          node.matches && (
            node.matches('.mt-cswitch__panel') ||
            node.matches('.mt-cswitch') ||
            node.matches('sht-country-switcher') ||
            node.matches('sht-localization')
          )
        ) { sawSwitcher = true; }
        if (node.querySelector && node.querySelector('.mt-cswitch__flag, .mt-cswitch__btn-flag, [data-mt-cswitch-search]')) {
          sawSwitcher = true;
        }
      }
    }
    if (sawSwitcher) enhance(document);
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
